import './Terms.scss';
import messages from './messagesTerms';
import { setTitle } from '../../utils/generic';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';

const Terms = () => {
  const intl = useIntl();

  const TERMS_QA = [
    {
      question: messages.PERSONAL_DATA_COLLECT_1_Q,
      anwser: messages.PERSONAL_DATA_COLLECT_1_A
    },
    {
      question: messages.PERSONAL_DATA_COLLECT_2_Q,
      anwser: messages.PERSONAL_DATA_COLLECT_2_A
    },
    {
      question: messages.PERSONAL_DATA_COLLECT_3_Q,
      anwser: messages.PERSONAL_DATA_COLLECT_3_A
    },
    {
      question: messages.PERSONAL_DATA_COLLECT_4_Q,
      anwser: messages.PERSONAL_DATA_COLLECT_4_A
    },
    {
      question: messages.PERSONAL_DATA_COLLECT_5_Q,
      anwser: messages.PERSONAL_DATA_COLLECT_5_A
    }
  ];

  useEffect(() => {
    setTitle(intl.formatMessage({ ...messages.pageTitle }));
  }, []);

  return (
    <div className="page">
      <div className="container terms mt-4">
        <h2
          className="mb-5"
          dangerouslySetInnerHTML={{
            __html: intl.formatMessage({
              ...messages.PERSONAL_DATA_COLLECT_TITLE
            })
          }}
        />
        {TERMS_QA.map((qa, index) => (
          <div key={index}>
            <h4>{intl.formatMessage({ ...qa.question })}</h4>
            <p
              dangerouslySetInnerHTML={{
                __html: intl.formatMessage({ ...qa.anwser })
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Terms;
